import {gql} from '@apollo/client'

export const GET_ALL_TRANSPORTS = gql`
  query tranportList($after: String, $id: Float, $plate: String, $offset: Int) {
    transportList(after: $after, id: $id, plate: $plate, offset: $offset) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          description
          id
          plate
          sizeVolco
        }
      }
    }
  }
`
